import React, { useContext } from 'react';
import { HeadTags, PageMetaModel, populatePageMetaAppInput, ServerContext } from '@goodrx/x-core';
export const PageMeta = props => {
  const {
    page
  } = useContext(ServerContext);
  const pageMetaAppInput = populatePageMetaAppInput({
    description: '',
    page: page || {},
    title: ''
  });
  const pageMetaModel = new PageMetaModel({
    appInput: pageMetaAppInput,
    pageMeta: props
  });
  return /*#__PURE__*/React.createElement(HeadTags, {
    pageMetaModel: pageMetaModel
  });
};